import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
import store from "@/store";
import ElementUI from "element-ui";
Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/contract/index",
    hidden: true,
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/personal",
    component: Layout,
    alwaysShow: true,
    key: "6000",
    meta: { title: "人员管理", icon: "el-icon-user" },
    children: [
      {
        path: "index",
        name: "personal",
        key: "6100",
        component: () => import("@/views/personal/list/index"),
        meta: {
          title: "人员列表",
          permission: [
            {
              name: "查看列表",
              key: "6102",
            },
            {
              name: "新增人员",
              key: "6101",
            },
            {
              name: "编辑人员",
              key: "6104",
            },
            {
              name: "删除人员",
              key: "6103",
            },
          ],
        },
      },

      {
        path: "add",
        name: "personalAdd",
        hidden: true,
        component: () => import("@/views/personal/add/index"),
        meta: { title: "添加人员" },
      },
      {
        path: "role",
        name: "role",
        key: "7000",
        component: () => import("@/views/role/list/index"),
        meta: {
          title: "岗位列表",
          permission: [
            {
              name: "查看列表",
              key: "7003",
            },
            {
              name: "新增岗位",
              key: "7001",
            },
            {
              name: "编辑",
              key: "7002",
            },
            {
              name: "删除",
              key: "7004",
            },
          ],
        },
      },
      {
        path: "roleAdd",
        name: "roleAdd",
        hidden: true,
        component: () => import("@/views/role/add/index"),
        meta: { title: "添加岗位" },
      },
    ],
  },
  {
    path: "/approval",
    component: Layout,
    alwaysShow: true, 
    meta: { title: "审批管理", icon: "el-icon-s-check" }, 
    key: "8000",
    children: [
      {
        path: "config",
        name: "approvalConfig",
        key: "8100",
        component: () => import("@/views/approval/config/index"),
        meta: { 
          title: "审批配置",
          icon: "el-icon-s-check",
          permission:[
            {
              name: "查看列表",
              key: "8101",
            },
            
            ]
         },
      },
      {
        path: "handle",
        name: "approvalHandle",
        key: "8200",
        component: () => import("@/views/approval/handle/index"),
        meta: { 
          title: "审批处理",
          icon: "el-icon-s-check",
          permission:[
            {
              name: "查看列表",
              key: "8201",
            },
            {
              name: "审批",
              key: "8202",
            },
            {
              name: "查看合同",
              key: "8203",
            },
            ]
         },
      },
    ]
  },
  {
    path: "/company",
    component: Layout,
    children: [
      {
        path: "index",
        name: "Company",
        key: "4000",

        component: () => import("@/views/company/index"),
        meta: {
          title: "公司管理",
          icon: "el-icon-office-building",
          permission: [
            {
              name: "查看列表",
              key: "4004",
            },
            {
              name: "新增公司",
              key: "4001",
            },
            {
              name: "删除公司",
              key: "4002",
            },
            {
              name: "编辑公司",
              key: "4003",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/user",
    component: Layout,
    children: [
      {
        path: "index",
        name: "User",
        key: "2000",

        component: () => import("@/views/user/index"),
        meta: {
          title: "用户管理",
          icon: "el-icon-user",
          permission: [
            {
              name: "查看列表",
              key: "2002",
            },
            {
              name: "实名审核",
              key: "2001",
            },
            // {
            //   name: "审批",
            //   key: "2003",
            // },
          ],
        },
      },
    ],
  },
  {
    path: "/contract",
    component: Layout,
    children: [
      {
        path: "index",
        name: "Contract",
        key: "1000",
        component: () => import("@/views/contract/index"),
        meta: {
          title: "合同管理",
          icon: "el-icon-document",
          // 权限
          permission: [
            {
              name: "查看列表",
              key: "1007",
            },
            {
              name: "线下签署",
              key: "1001",
            },
            {
              name: "线上签署",
              key: "1002",
            },
            {
              name: "查看合同",
              key: "1003",
            },
            {
              name: "编辑合同",
              key: "1004",
            },
            {
              name: "修改状态",
              key: "1005",
            },
            {
              name: "删除合同",
              key: "1006",
            },
            // {
            //   name: "审批",
            //   key: "1008",
            // },
          ],
        },
      },
    ],
  },
  {
    path: "/wages",
    component: Layout,
    alwaysShow: true,
    meta: { title: "薪资管理", icon: "el-icon-tickets" },
    children: [
      {
        path: "index",
        name: "wages",
        key: "5000",

        component: () => import("@/views/wages/index"),
        meta: {
          title: "薪资列表",
          icon: "el-icon-tickets",
          permission: [
            {
              name: "查看列表",
              key: "5004",
            },
            {
              name: "导入工资单",
              key: "5001",
            },
            {
              name: "导出工资单",
              key: "5002",
            },
            {
              name: "工资单详情",
              key: "5003",
            },
          ],
        },
      },
      {
        path: "detail",
        name: "wagesDetail",
        component: () => import("@/views/wages/detail"),
        hidden: true,
        meta: { title: "薪资详情" },
        key: '5003'
      },
    ],
  },
 
  {
    path: "/welfare",
    component: Layout,
    meta: { title: "福利动态", icon: "el-icon-s-goods" },
    children: [
      {
        path: "list",
        key: "3000",

        component: () => import("@/views/welfare/index"),
        name: "WelfareList",
        meta: {
          title: "福利动态",
          icon: "el-icon-s-goods",
          permission: [
            {
              name: "查看列表",
              key: "3002",
            },
            {
              name: "处理状态",
              key: "3001",
            },
          ],
        },
      },
    ],
  },
 
  
 
];

const createRouter = () =>
  new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// 重置路由
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

function findRoute(routers,name){

  for (let index = 0; index < routers.length; index++) {
    const element = routers[index];
    if(element.name == name){
      return element;
    }
    if(element.children){
      const result = findRoute(element.children,name);
      if(result){
        return result;
      }
    }
  }

  return null;
}

// 路由跳转检查是否有权限
async function checkPermission(to, from, next) {

  let { name } = to;
    // 等待权限数据获取完成
  await store.dispatch('user/getUserAuthority')
  console.log(to,name);
  
  // 递归根据name进行查找
  let route = findRoute(constantRoutes,name)
  console.log(route);
    
    
  const token = localStorage.getItem("token");

  if (token) {
    if(route){
      const hasPermission = store.state.user.authority.includes(route.key)
      if (hasPermission) {
        next();
      } else {
        ElementUI.Message.error("没有权限");
      }
    }else {

      ElementUI.Message.error("没有权限");
    }
  } else {
    
    next("/login");
  }
}

// 路由守卫
router.beforeEach((to, from, next) => {
  // console.log(to)
  // console.log(from)
  // next();
  const token = localStorage.getItem("token");
  if (to.path === "/login") {
   next()
  } else {
    if (token) {
      checkPermission(to, from, next);
    } else {
      next("/login");
    }
  }
});

export default router;
